import React from "react";
import { Block } from "@/components/form/Block";
import { FormLabel } from "@/components/form/FormLabel";
import { Box, Typography } from "@mui/material";
import { GetSeminarsQuery } from "@/graphql/codegen/graphql";

interface SeminarCapacityFullProps {
  author: GetSeminarsQuery["seminars"][0]["author"];
}

export const SeminarCapacityFull: React.FC<SeminarCapacityFullProps> = ({
  author,
}) => {
  return (
    <Block>
      <FormLabel>
        <Typography mb={3} fontSize={"2rem"}>
          Seminář je plně obsazen
        </Typography>
        <Box>
          Je nám líto, ale na danou akci se již není možno přihlásit. Chcete-li
          se přihlásit jako náhradník, kontaktujte prosím:
          {author && (
            <Box>
              <Box
                sx={{ mt: 2, display: "inline-flex", flexDirection: "column" }}
              >
                <Typography fontWeight={500}>
                  {author.firstName} {author.lastName}
                </Typography>
                <a href={`mailto:${author.email}`}>{author.email}</a>
                <div>{author.phone}</div>
              </Box>
            </Box>
          )}
        </Box>
      </FormLabel>
    </Block>
  );
};
